import { useRef } from 'react';
import { usePhoneCalls } from '../../../../contexts/PhoneCallsContext/PhoneCallsContext';
import { IncomingCallModal, IncomingCallModalRef } from '../IncomingCallModal/IncomingCallsModal';
import { IncomingCallPopup } from '../IncomingCallPopup/IncomingCallPopup';
import { OutgoingCallModal } from '../OutgoingCallModal/OutgoingCallModal';

export const GlobalCallModals = () => {
  const {
    isOutgoingCallModalOpen,
    isIncomingCallModalOpen,
    isAgentReceivingCall,
    incomingCallType,
    activeCallState,
    transferData,
    cancelTransfer,
  } = usePhoneCalls();

  const incomingCallModalRef = useRef<IncomingCallModalRef>(null);

  return (
    <>
      <IncomingCallModal ref={incomingCallModalRef} open={isIncomingCallModalOpen} />

      <OutgoingCallModal open={isOutgoingCallModalOpen} />

      <IncomingCallPopup
        open={isAgentReceivingCall}
        type={incomingCallType}
        incomingCall={activeCallState.call}
      />
    </>
  );
};
